<template>
    <client-page>
        <mypage-layout title="재고현황">
            <page-section class="page-section--xs pt-0">
                <template slot="containerImmersive">
                    <inventory-status />
                </template>
            </page-section>

            <inventory-form v-model="selected" @input="emit" />

            <inventory-list v-model="selected" v-on="{ setSummary, input: emit }" />

            <page-section class="page-section--xs pb-0">
                <template slot="containerImmersive">
                    <inventory-foot v-bind="{ summary }" />
                </template>
            </page-section>
        </mypage-layout>
    </client-page>
</template>

<script>
import ClientPage from "@/components/client/templates/client-page.vue";
import MypageLayout from "@/components/client/templates/mypage-layout.vue";
import InventoryStatus from "@/components/client/mypage/inventory/inventory-status.vue";
import PageSection from "@/components/client/templates/page-section.vue";
import InventoryFoot from "@/components/client/mypage/inventory/inventory-foot.vue";
import InventoryForm from "@/components/client/mypage/inventory/inventory-form.vue";
import InventoryList from "@/components/client/mypage/inventory/inventory-list.vue";

export default {
    components: {
        ClientPage,
        MypageLayout,
        InventoryStatus,
        PageSection,
        InventoryFoot,
        InventoryForm,
        InventoryList,
    },
    data: () => ({
        selected: [],
        summary: undefined,
    }),
    methods: {
        setSummary(summary = {}) {
            this.summary = { ...summary };
        },
        emit() {
            this.selected = [...this.selected];
        },
    },
};
</script>

<style lang="scss" scoped></style>
